<template>
  <div>
    <div id="busqueda" v-if="mostrarBusqueda">
      <v-card max-width="1030" class="mx-auto mt-5" id="busqueda">
        <v-card-title>
          <h4>Consulta de Ordenes de Pago</h4>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="buscarOdenPago" id="busqueda-form">
            <v-text-field
              type="text"
              label="Ingrese un valor para buscar"
              hint="ej. Nombres, Cedula, CodMemSq, Nombres de Herederos, etc."
              v-model="valor"
              maxlength="100"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
          <v-btn color="info" @click="buscarOdenPago">Buscar</v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn color="info" small @click="descargarEstadosPagos()"
            >Descargar estados de pagos</v-btn
          >
          <v-spacer></v-spacer> -->
          <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
        </v-card-actions>
      </v-card>

      <v-card
        id="autores"
        v-if="autores.length > 0"
        max-width="1030"
        class="mx-auto mt-5"
      >
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Tipo</th>
                <th class="text-left">Nombre Autor</th>
                <th class="text-left">Herederos</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="autor in autores" :key="autor.id">
                <td>
                  idSocio:{{ +autor.gestionIdSocio }} codSocio:{{
                    autor.gestionCodSocio
                  }}} cedula: {{ autor.cedula }}} CodMemSQ:
                  {{ autor.codMemSq }} IP: {{ autor.ip_name }}
                </td>
                <td>{{ autor.gestionSocioEstado }}</td>
                <td>{{ autor.nombreCompleto }}</td>
                <td>
                  <ul>
                    <li v-for="ah in autor.autoresHerederos" :key="ah.id">
                      {{
                        ah.heredero.nombres +
                        " " +
                        ah.heredero.apellidos +
                        "(" +
                        ah.porcentaje +
                        "%)"
                      }}
                    </li>
                  </ul>
                </td>
                <td>
                  <v-btn
                    v-if="!autor.sinLiquidacion"
                    small
                    color="success"
                    @click="buscarLiquidacion(autor)"
                    >Liquidacion</v-btn
                  >
                  <span v-else>No posee liquidaciones</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </div>

    <div>
      <v-card
        id="autorSeleccionado"
        v-if="autorSeleccionado"
        max-width="1030"
        class="mx-auto mt-5"
      >
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Codigo Socio</th>
                <th class="text-left">Tipo</th>
                <th class="text-left">Nombre Autor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ autorSeleccionado.gestionCodSocio }}</td>
                <td>
                  {{
                    autorSeleccionado.memType
                      ? autorSeleccionado.memType.trim()
                      : ""
                  }}
                </td>
                <td>{{ autorSeleccionado.nombreCompleto }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <!-- <v-card id="liquidacion" v-if="liquidaciones.length > 0" max-width="1030" class="mx-auto mt-5">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Generacion</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="liq in liquidaciones" :key="liq.id">
                <td>{{ liq.generacion.descripcion}}</td>
                <td>
                  <v-btn
                    small
                    color="success"
                    v-if="liquidaciones.length > 1"
                    @click="buscarLiquidacionResumen(liq.id)"
                  >Ver Resumen</v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>-->

      <v-card
        id="liquidacionResumen"
        v-if="liquidacionResumen.length > 0"
        max-width="1030"
        class="mx-auto mt-5"
      >
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Asignacion</th>
                <th class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="liq in liquidacionResumen" :key="liq.asignacion">
                <td class="text-left">{{ liq.asignacion }}</td>
                <td class="text-right">{{ liq.monto | numberFormat }}</td>
              </tr>
              <tr>
                <td class="text-left teal lighten-4">NETO</td>
                <td class="text-right teal lighten-4">
                  {{ total | numberFormat }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" small @click="descargar()"
            >Descargar Detalle</v-btn
          >
          <v-btn color="info" small @click="descargarResumen()"
            >Descargar Resumen</v-btn
          >
          <EnviarCorreo :id="this.liquidacion.id" v-if="this.liquidacion" />
          <v-spacer></v-spacer>
          <v-btn color="info" @click="volver()">Volver</v-btn>
        </v-card-actions>
      </v-card>

      <v-card
        id="liquidacionDetalle"
        max-width="900"
        class="mx-auto mt-5"
        v-if="false"
        scrollable
      >
        <v-data-table
          dense
          sort-by="asignacion.nombre"
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="liquidacion.liquidacionesDetalles"
          class="elevation-1"
        >
          <template>{{ item.monto | numberFormat }}</template>
          <!-- <template v-slot:item.asignacion.nombre="{ item }">{{ item.asignacion.nombre.substring(0,6) + '...' }}</template>
          <template v-slot:item.tema.nombre ="{ item }">{{ item.tema.nombre.substring(0,6) + '...' }}</template>-->
        </v-data-table>

        <!-- <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Tema</th>
                <th class="text-left">%</th>
                <th class="text-right">Monto</th>
                <th class="text-left">Asignacion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="liq in liquidacion.liquidacionesDetalles" :key="liq.id">
                <td class="text-left">{{ liq.tema ? liq.tema.nombre : '' }}</td>
                <td class="text-left">{{ liq.tema ? liq.participacion : '' }}</td>
                <td class="text-right">{{ liq.monto | numberFormat}}</td>
                <td class="text-left">{{ liq.asignacion.nombre}}</td>
              </tr>
              <tr>
                <td class="text-left teal lighten-4">NETO</td>
                <td class="text-left teal lighten-4"></td>
                <td class="text-right teal lighten-4">{{ total | numberFormat}}</td>
                <td class="text-left teal lighten-4"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>-->
      </v-card>
    </div>

    <v-card
      id="ordenesPagos"
      v-if="mostrarBusqueda && ordenesPago.length > 0"
      max-width="1300"
      class="mx-auto mt-5"
    >
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="ordenesPago" :search="search">
          <template v-slot:[`item.titular.id`]="props">
            id:{{ +props.item.titular.id }} <br />
            CI: {{ props.item.titular.cedula }} <br />
            CodMemSQ: {{ props.item.titular.codMemSq }} <br />
            IP: {{ props.item.titular.ipName }}
          </template>

          <template v-slot:[`item.monto`]="props">
            {{ props.item.monto | numberFormat }}
          </template>
          <template v-slot:[`item.pago`]="props">
            <ul>
              <li v-if="props.item.titular.formaCobro">
                Predeterminado:
                <b>{{ props.item.titular.formaCobro }}</b>
              </li>

              <li v-for="pago in props.item.pagosDetalle" :key="pago.id">
                {{ pago.monto | numberFormat }}
                {{ pago.pago.medioPago.nombre }}
                {{ pago.pago.fechaApertura | dateFormat }}
              </li>
            </ul>
          </template>
          <template v-slot:[`item.liquidacion.autor.nombres`]="props">
            <div
              v-if="
                props.item.titular.id != props.item.liquidacion.autor.id
              "
            >
              {{
                props.item.liquidacion.autor.nombres +
                " " +
                props.item.liquidacion.autor.apellidos
              }}
            </div>
          </template>
          <template v-slot:[`item.beneficiario.nombres`]="props">
            {{
              props.item.beneficiario.nombres +
              " " +
              props.item.beneficiario.apellidos
            }}
          </template>
          <template v-slot:[`item.titular.nombres`]="props">
            {{
              props.item.titular.nombres + " " + props.item.titular.apellidos
            }}
            <div v-if="props.item.titular.feVida">
              fe de vida
              <v-icon class="green--text">check</v-icon>
            </div>
            <div v-else>
              fe de vida
              <v-icon class="red--text">error</v-icon>
            </div>
          </template>
          <template v-slot:[`item.estado`]="props">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-on="on"
                  v-bind="attrs"
                  id="chip"
                  :class="`my-2 caption ${props.item.estado}`"
                  >{{ props.item.estado }}</v-chip
                >
              </template>
              <span>{{ props.item.observacion }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.saldo`]="props">
            {{ saldoOP(props.item) | numberFormat }}
          </template>
          <template v-slot:[`item.controls`]="props">
            <v-btn
              v-if="
                props.item.titular.id != props.item.liquidacion.autor.id &&
                props.item.estado == 'Valido'
              "
              small
              @click="descargarResumenSusesorio(props.item)"
              >Resumen
              <v-icon>save_alt</v-icon>
            </v-btn>
            <v-btn
              v-else
              small
              class="btn btn-primary btn-sm"
              @click="descargarResumenOp(props.item)"
            >
              Resumen
              <v-icon>save_alt</v-icon>
            </v-btn>

            <v-btn
              small
              color="success"
              @click="buscarLiquidacionResumen(props.item)"
              >Liquidacion</v-btn
            >
          </template>
        </v-data-table>
        <!-- <v-divider></v-divider>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Distribucion</th>
                <th class="text-left">ID</th>
                <th class="text-left">Tipo</th>
                <th class="text-left">Beneficiario</th>
                <th class="text-left">Causante</th>
                <th class="text-right">Monto</th>
                <th class="text-left">Pago</th>
                <th class="text-right">Saldo</th>
                <th class="text-center">Estado</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="op in ordenesPago" :key="op.id">
                <td>{{ op.generacion.descripcion }}</td>
                <td>
                  IdPer: {{ +op.beneficiario.id }} IdSocio:
                  {{ +op.beneficiario.gestionIdSocio }} Cedula:{{
                    +op.beneficiario.cedula
                  }}
                  CodMem: {{ op.beneficiario.codMemSq }} IP:
                  {{ op.beneficiario.ipName }}
                </td>
                <td>
                  {{ op.beneficiario.gestionSocioEstado }}
                </td>
                <td>
                  {{
                    op.beneficiario.nombres + " " + op.beneficiario.apellidos
                  }}
                  <div
                    v-if="
                      op.beneficiario.id != op.liquidacion.autor.id &&
                      op.estado == 'Valido'
                    "
                  >
                    <v-btn
                      color="info"
                      small
                      @click="descargarResumenSusesorio(op)"
                      >Resumen</v-btn
                    >
                  </div>
                  <div v-else>
                    <v-btn color="info" small @click="descargarResumenOp(op)"
                      >Resumen</v-btn
                    >
                  </div>
                </td>
                <td>
                  <div v-if="op.beneficiario.id != op.liquidacion.autor.id">
                    {{
                      op.liquidacion.autor.nombres +
                      " " +
                      op.liquidacion.autor.apellidos
                    }}
                  </div>
                </td>
                <td class="text-right">{{ op.monto | numberFormat }}</td>
                <td>
                  <ul>
                    <li v-if="op.beneficiario.formaCobro">
                      Predeterminado:
                      <b>{{ op.beneficiario.formaCobro }}</b>
                    </li>

                    <li v-for="pago in op.pagosDetalle" :key="pago.id">
                      {{ pago.monto | numberFormat }}
                      {{ pago.pago.medioPago.nombre }}
                      {{ pago.pago.fechaApertura | dateFormat }}
                    </li>
                  </ul>
                </td>
                <td class="text-right">{{ saldoOP(op) | numberFormat }}</td>

                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-on="on"
                        v-bind="attrs"
                        id="chip"
                        :class="`my-2 caption ${op.estado}`"
                        >{{ op.estado }}</v-chip
                      >
                    </template>
                    <span>{{ op.observacion }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-btn
                    small
                    color="success"
                    @click="buscarLiquidacionResumen(op)"
                    >Liquidacion</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import numeral from "numeral";
import EnviarCorreo from "./EnviarCorreo.vue";
import { saveAs } from "file-saver";

export default {
  components: {
    EnviarCorreo,
  },
  data() {
    return {
      autores: [],
      search: "",
      liquidaciones: [],
      liquidacionResumen: [],
      liquidacion: null,
      ordenesPago: [],
      mostrarBusqueda: true,
      autorSeleccionado: null,
      valor: "",
      errorMessage: "",
      dialog: false,
      headers: [
        { text: "Distribucion", value: "generacion.nombreCorto" },
        { text: "Id Titular", value: "titular.id" },
        { text: "Tipo", align: "start", value: "beneficiario.memType" },
        { text: "Beneficiario", value: "beneficiario.nombres" },
        { text: "Titular", value: "titular.nombres" },
        { text: "Causante", value: "liquidacion.autor.nombres" },
        { text: "Monto", align: "end", value: "monto", sortable: false },
        { text: "Pago", value: "pago", sortable: false },
        { text: "Saldo", align: "end", value: "saldo", sortable: false },
        { text: "Estado", value: "estado" },
        { text: "Accion", value: "controls", sortable: false },
      ],
    };
  },

  methods: {
    // buscarAutor() {
    //   this.errorMessage = "";
    //   this.autores = [];
    //   this.liquidaciones = [];
    //   this.liquidacionResumen = [];

    //   if (!this.valor) {
    //     this.errorMessage = "Complete algun dato para buscar";
    //     return;
    //   }

    //   axios
    //     .get("/consulta/autor/?valor=" + this.valor)
    //     .then((response) => {
    //       console.log(response.data);
    //       if (Array.isArray(response.data)) {
    //         if (this.$store.getters.user.roles.includes("DISTRIBUCION")) {
    //           this.autores = response.data.map((autor) => {
    //             return { ...autor, sinLiquidacion: false };
    //           });
    //         } else {
    //           console.log("filtrado por cerrados")
    //           this.autores = response.data.filter( row => row.generacion.estado === 'Cerradoo')
    //             .map((autor) => {
    //               return { ...autor, sinLiquidacion: false };
    //             });
    //         }

    //         // if (this.autores.length === 1) {
    //         //   this.buscarLiquidacion(this.autores[0]);
    //         // }
    //       } else {
    //         this.errorMessage = "Sin datos";
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.errorMessage = "Error en la consulta";
    //     });
    // },
    // buscarLiquidacion(autor) {
    //   this.autorSeleccionado = autor;

    //   axios
    //     .get("/autor/" + autor.id + "/liquidacion")
    //     .then(response => {
    //       this.liquidaciones = response.data;
    //       if (!this.liquidaciones || this.liquidaciones.length === 0) {
    //         autor.sinLiquidacion = true;
    //       }

    //       if (this.liquidaciones.length === 1) {
    //         this.buscarLiquidacionResumen(this.liquidaciones[0].id);
    //       }

    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.errorMessage = "Error en la consulta";
    //     });
    // },
    buscarLiquidacionResumen(op) {
      //this.buscarLiquidacionDetalle(liquidacionId);
      axios
        .get("/autor/0/liquidacion/" + op.liquidacion.id)
        .then((response) => {
          this.autorSeleccionado = op.liquidacion.autor;
          this.liquidacionResumen = response.data;
          this.liquidacion = op.liquidacion;
          this.mostrarBusqueda = false;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    buscarLiquidacionDetalle(liquidacionId) {
      axios
        .get("/liquidacion/" + liquidacionId)
        .then((response) => {
          this.liquidacion = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    buscarOdenPago() {
      this.errorMessage = "";
      this.autores = [];
      this.liquidaciones = [];
      this.liquidacionResumen = [];

      if (!this.valor) {
        this.errorMessage = "Complete algun dato para buscar";
        return;
      }

      axios
        .get("/consulta/ordenPago/findByBeneficiario?nombres=" + this.valor)
        .then((response) => {
          //removemos los pagos anulados

          if (this.$store.getters.user.roles.includes("DISTRIBUCION")) {
            
            let ops = response.data;
            ops.forEach((op) => {
              op.pagosDetalle = op.pagosDetalle.filter(
                (pd) => pd.estado != "Anulado"
              );
            });

            this.ordenesPago = ops;
            
            
          } else {
            let ops = response.data.filter(
              (row) => row.generacion.estado === "Cerrado"
            );

            ops.forEach((op) => {
              op.pagosDetalle = op.pagosDetalle.filter(
                (pd) => pd.estado != "Anulado"
              );
            });

            this.ordenesPago = ops;
          }

          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    volver() {
      this.errorMessage = "";
      this.autorSeleccionado = null;
      // this.liquidaciones = [];
      // this.ordenesPago = [];
      // this.liquidacion = null;
      this.liquidacionResumen = [];
      this.mostrarBusqueda = true;
      this.email = null;
    },
    descargar() {
      axios
        .get("/report/liquidacion/" + this.liquidacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarResumen() {
      axios
        .get("/report/liquidacionResumen/" + this.liquidacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarResumenSusesorio(op) {
      axios
        .get("/report/liquidacionResumenSusesorio/" + op.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarResumenOp(op) {
      axios
        .get("/report/ordenpago/resumen/" + op.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarEstadosPagos() {
      axios
        .get("/report/estadosPagos/")
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    saldoOP(op) {
      return op.monto - op.pagosDetalle.reduce((a, b) => a + b.monto, 0);
      //return op.monto - 10;
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  mounted() {
    if (!numeral.locale) {
      numeral.register("locale", "es", {
        delimiters: {
          thousands: ".",
          decimal: ",",
        },
        currency: {
          symbol: "GPY",
        },
      });

      numeral.locale("es");
    }
  },
  computed: {
    total() {
      return this.liquidacionResumen.reduce((a, b) => +a + b.monto, 0);
    },
  },
  filters: {
    // formatDate(value) {
    //   if (value) {
    //     return moment(String(value)).format("MM/DD/YYYY hh:mm");
    //   }
    // },
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    numberToHHMM(value) {
      if (value) {
        return moment(value).format("hh:mm");
      }
    },
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
};
</script>

<style scoped>
div {
  margin: 5px 5px;
}

#chip.Valido {
  background: lightgreen;
}

#chip.Anulado {
  background: lightcoral;
}

#chip.Retenido {
  background: lightcoral;
}

#chip.Reservado {
  background: lightcoral;
}
</style>
